import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  display: flex;
  flex-direction: row;
  width: 100%;

  .select-item {
    width: 100%;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    
  }
`;
